"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _react = _interopRequireDefault(require("react"));
var _langLibrary = _interopRequireDefault(require("@deosite/helpers/langLibrary"));
var _Box = _interopRequireDefault(require("@commerce-ui/core2/Box"));
var _LinkRaw = _interopRequireDefault(require("@commerce-ui/core2/LinkRaw"));
var _MessageHandlerProvider = require("@deosite/api/hooks/common/MessageHandlerProvider");
var _RouteContext = require("@deosite/lib/RouteContext");
var __jsx = _react["default"].createElement;
var CopyIcon = function CopyIcon(props) {
  return __jsx("svg", props, __jsx("path", {
    d: "M22 6v16H6V6h16zm2-2H4v20h20V4zM0 21V0h21v2H2v19H0z"
  }));
};
CopyIcon.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24"
};
var defaultProps = {
  minified: false,
  minifiedPaddingBottom: "s5",
  bigTitleFontMinified: "s_sans_bold",
  salesTextFont: "s_sans",
  subheadingFont: "l",
  bigTitleFont: "xl_sans"
};
var SalesBox = function SalesBox(props) {
  var banner = props.banner,
    background = props.background,
    _props$minified = props.minified,
    minified = _props$minified === void 0 ? defaultProps.minified : _props$minified,
    _props$minifiedPaddin = props.minifiedPaddingBottom,
    minifiedPaddingBottom = _props$minifiedPaddin === void 0 ? defaultProps.minifiedPaddingBottom : _props$minifiedPaddin,
    _props$bigTitleFontMi = props.bigTitleFontMinified,
    bigTitleFontMinified = _props$bigTitleFontMi === void 0 ? defaultProps.bigTitleFontMinified : _props$bigTitleFontMi,
    _props$salesTextFont = props.salesTextFont,
    salesTextFont = _props$salesTextFont === void 0 ? defaultProps.salesTextFont : _props$salesTextFont,
    _props$subheadingFont = props.subheadingFont,
    subheadingFont = _props$subheadingFont === void 0 ? defaultProps.subheadingFont : _props$subheadingFont,
    _props$bigTitleFont = props.bigTitleFont,
    bigTitleFont = _props$bigTitleFont === void 0 ? defaultProps.bigTitleFont : _props$bigTitleFont;
  var bigTitle = banner.bigTitle,
    promoCode = banner.promoCode,
    subheading = banner.subheading,
    linkText = banner.linkText,
    url = banner.url;
  if (!banner) {
    return null;
  }
  var _useRouteContext = (0, _RouteContext.useRouteContext)(),
    Link = _useRouteContext.Link;
  var _useHandleMessage = (0, _MessageHandlerProvider.useHandleMessage)(),
    handleMessage = _useHandleMessage.handleMessage;
  var translations = {
    promoCodeCopied: (0, _langLibrary["default"])("Promo code was added to clipboard")
  };
  var salesBannerWrapperStyles = {
    width: "100%",
    bg: background ? background : "negative",
    color: "white",
    py: "s6",
    mb: [0, null, null, minifiedPaddingBottom],
    font: bigTitleFontMinified,
    justifyContent: "center",
    display: "flex",
    px: ["s8", null, null, 0]
  };
  if (minified) {
    if (promoCode) {
      var title = bigTitle === null || bigTitle === void 0 ? void 0 : bigTitle.split(promoCode);
      return __jsx(_Box["default"], {
        sx: salesBannerWrapperStyles
      }, __jsx(_Box["default"], null, "".concat(subheading, " ").concat(title[0]), __jsx(_Box["default"], {
        as: "span",
        id: "promoCode",
        sx: {
          svg: {
            fill: "white",
            width: 11,
            height: 15,
            ml: 4
          },
          cursor: "default"
        }
      }, __jsx(_Box["default"], {
        onClick: (/*#__PURE__*/function () {
          var _ref = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee(event) {
            var _event$target$innerTe;
            var textToCopy;
            return _regenerator["default"].wrap(function _callee$(_context) {
              while (1) {
                switch (_context.prev = _context.next) {
                  case 0:
                    textToCopy = (_event$target$innerTe = event.target.innerText) === null || _event$target$innerTe === void 0 ? void 0 : _event$target$innerTe.replace(/\s/g, "");
                    _context.next = 3;
                    return navigator.clipboard.writeText(textToCopy);
                  case 3:
                    handleMessage(translations.promoCodeCopied, false, false);
                  case 4:
                  case "end":
                    return _context.stop();
                }
              }
            }, _callee);
          }));
          return function (_x) {
            return _ref.apply(this, arguments);
          };
        }()),
        as: "span",
        sx: {
          cursor: "pointer"
        }
      }, promoCode), __jsx(CopyIcon, null)), bigTitle && title[1] && "".concat(title[1])), __jsx(_Box["default"], {
        sx: {
          font: salesTextFont,
          textDecoration: "underline",
          ml: 5,
          mt: -1
        }
      }, __jsx(Link, {
        href: url
      }, __jsx(_LinkRaw["default"], {
        title: linkText
      }, linkText))));
    }
    return __jsx(Link, {
      href: url
    }, __jsx(_LinkRaw["default"], {
      title: linkText
    }, __jsx(_Box["default"], {
      sx: salesBannerWrapperStyles
    }, __jsx(_Box["default"], null, "".concat(subheading, " ").concat(bigTitle)), "\xA0", __jsx(_Box["default"], {
      sx: {
        font: salesTextFont,
        textDecoration: "underline"
      }
    }, linkText))));
  }
  return __jsx(Link, {
    href: url
  }, __jsx(_LinkRaw["default"], {
    title: linkText
  }, __jsx(_Box["default"], {
    sx: {
      width: "100%",
      bg: background ? background : "negative",
      color: "white",
      py: "s8",
      px: "18%",
      display: "flex",
      flexDirection: ["column", null, null, "row"],
      justifyContent: "space-between",
      textAlign: ["center", null, null, "left"]
    }
  }, __jsx(_Box["default"], null, subheading && __jsx(_Box["default"], {
    sx: {
      font: subheadingFont,
      mb: "s5"
    }
  }, subheading), bigTitle && __jsx(_Box["default"], {
    sx: {
      font: bigTitleFont
    }
  }, bigTitle)), linkText && __jsx(_Box["default"], {
    sx: {
      width: ["100%", null, null, "auto"],
      mt: "s8",
      font: salesTextFont,
      alignSelf: "flex-end",
      textDecoration: "underline",
      textAlign: ["right", null, null, "center"]
    }
  }, linkText))));
};
var _default = SalesBox;
exports["default"] = _default;